import script from "./bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./bottom.vue?vue&type=script&setup=true&lang=js"

import "./bottom.vue?vue&type=style&index=0&id=589e0149&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589e0149"]])

export default __exports__